<script lang="ts">
  import { mdiDotsHorizontal } from "@mdi/js"
  import Icon from "../../../primitives/_modules/icon/index"

  type MenuCapableElement = HTMLElement & {
    toggleMenu?: () => void
  }

  type Props = {
    widgetElement?: MenuCapableElement | HTMLElement | null
    title?: string
    disabled?: boolean
    class?: string
  }

  let {
    widgetElement = null,
    title = "Weitere Optionen",
    disabled = false,
    class: className = "",
  }: Props = $props()

  const canToggle = $derived(Boolean(widgetElement))

  const handleToggleMenu = () => {
    if (disabled) return

    const target = widgetElement as MenuCapableElement | null

    if (typeof target?.toggleMenu !== "function") return

    target.toggleMenu()
  }
</script>

<button
  class={`btn assist-widget-menu-button ${className}`.trim()}
  type="button"
  onclick={handleToggleMenu}
  {title}
  aria-label={title}
  aria-haspopup="menu"
  disabled={disabled || !canToggle}
>
  <Icon path={mdiDotsHorizontal} />
</button>
